import axios from "axios";
import { RouterProvider, createBrowserRouter } from "react-router-dom";
import Dashboard from "./admin/DashBoard.js";
import Protect from "./admin/Protect.js";
import Home from "./Home/Home.js";
import Booking from "./Booking/Booking.js";
import Login from "./login/Login.js";
import Events from "./events/Events.js";
import BookingForm from "./Booking/BookingForm.js";
import CBookingForm from "./Booking/CBookingForm.js";
import Transaction from "./Booking/Transaction.js";
import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import Activities from "./Home/Activities.js";
import AddBoat from "./admin/AddBoat.js"

// Set once globally so every axios call in the app sends credentials
axios.defaults.withCredentials = true;

const router = createBrowserRouter([
  { path: "/", element: <Home /> },
  { path: "/admin", element: <Protect><Dashboard /></Protect> , children: [{ path: "book", element: <BookingForm /> }]},
  { path: "/activities", element: <Activities /> },
  { path: "/transaction", element: <Transaction /> },
  { path: "/events", element: <Events /> },
  {
    path: "/booking",
    element: <Booking />,
    children: [{path: "booking-class", element: <CBookingForm />},{ path: ":id", element: <BookingForm /> }],
  },
  {
    path: "/login", element: <Login />,
  },
  {
    path: "/add-boat", element: <Protect><AddBoat /></Protect>
  }
]);

function App() {
  return (
    <div className="App">
      <RouterProvider router={router}></RouterProvider>
      <ToastContainer
/>

    </div>
  );
}

export default App;
